/* eslint-disable max-classes-per-file */
/**
 * This file exports the Clientflow API Class.
 */

import { TypedAsyncCommandApi, JsonRpc } from '@/lib/web-api'
import TClientFlowCommands from '../methodDefinitions'

export class ClientFlowApi extends TypedAsyncCommandApi<
  TClientFlowCommands,
  JsonRpc.Sender
  > {
  public async sayHi(name: string) {
    const cmd = this.makeCmd('sayHi', { name })
    const response = await this.sendCmd(cmd)
    return response
  }

  public sayHi2(name: string) {
    return this.makeCmd('sayHi', { name })
  }

  public async addNewClient(args: {
    name: string;
    email: string;
    therapistId: string;
    inviteMailSubject: string;
    inviteMailBody: string;
    isDummy: boolean;
  }) {
    const cmd = this.makeCmd('createClient', args)
    return cmd
  }

  public async updateClientContactInfo(args: {
    clientId: string;
    name?: string;
    phone?: string;
    email?: string;
    isDummy?: boolean;
  }) {
    const cmd = this.makeCmd('updateClientContactInfo', args)
    return cmd
  }

  public async addSession(args: {
    date: string;
    note?: string;
    clientId: string;
    therapistId: string;
    localReference?: string;
  }) {
    const cmd = this.makeCmd('addSession', args)
    return cmd
  }

  public async updateSession(args: {
    date: string;
    note: string;
    clientId: string;
    therapistId: string;
    sessionId: string;
  }) {
    const cmd = this.makeCmd('updateSession', args)
    return cmd
  }

  public async deleteSession(args: {
    sessionId: string;
    clientId: string;
  }) {
    const cmd = this.makeCmd('deleteSession', args)
    return cmd
  }

  public async deleteClient(args: {
    clientId: string;
  }) {
    const cmd = this.makeCmd('deleteClient', args)
    return cmd
  }

  public async updateParticipantInfo(args: {
    studyId: string;
    participantId: string;
    consent?: string;
    attachedDate: string;
    sessionCount: string;
    lastSessionDate: string | null;
    lastReminderDate: string | null;
    adminNote: string | null;
    }) {
    const cmd = this.makeCmd('updateParticipantInfo', args)
    return cmd
  }
}
